// extracted by mini-css-extract-plugin
module.exports = {"hotLink":"MarkDownComp_hotLink__llxUF","markDownComp":"MarkDownComp_markDownComp__TVO9k","ulStyle":"MarkDownComp_ulStyle__aSeA8"};